import React from "react";
import "./Benefits.css";

const benefits = [
  {
    title: "Mehr Zeit",
    text: "Sie sparen eine Menge Zeit, weil Sie nicht mehr ständig einen neuen Partner suchen müssen.",
  },
  {
    title: "Keine Kopfschmerzen",
    text: "Sie haben einen klaren Kopf, weil Sie sich auf die wichtigen Dinge konzentrieren können.",
  },
  {
    title: "Geld sparen",
    text: "Sie sparen Geld, weil Sie von einem optimalen Preis-/Leistungsverhältnis profitieren.",
  },
  {
    title: "Höhere Umsätze",
    text: "Sie profitieren von höheren Umsätzen, weil Ihre Kunden und das Team glücklicher sind.",
  },
];

const Benefits = () => (
  <section className="benefits-section">
    <h2>Ihre Vorteile liegen klar auf der Hand</h2>
    <div className="benefits-grid">
      {benefits.map((b, i) => (
        <div className="benefit-box" key={i}>
          <h4>{b.title}</h4>
          <p>{b.text}</p>
        </div>
      ))}
    </div>
  </section>
);

export default Benefits;
